<template>
    <path
        d="M5.62363 6.5002L0.879883 1.75645L2.23497 0.401367L8.3338 6.5002L2.23497 12.599L0.879883 11.244L5.62363 6.5002Z"
        fill="#606060" />
</template>